const SPECIAL_PROJECT_DESTINATIONS = {
  freitag: '/freitag',
  ramadan2025: '/ramadan2025',
  ramadan2026: '/rmdn2026-embed',
  dhullhijjah2026: '/dhullhijjah2026-embed',
  dh25: '/dh25',
};

export const isSpecialProjectUrl = (projectUrl) =>
  Object.prototype.hasOwnProperty.call(
    SPECIAL_PROJECT_DESTINATIONS,
    String(projectUrl || '').trim().toLowerCase()
  );

export const getProjectDestination = (projectUrl) => {
  const normalizedUrl = String(projectUrl || '').trim();

  if (!normalizedUrl) return null;

  return (
    SPECIAL_PROJECT_DESTINATIONS[normalizedUrl.toLowerCase()] ||
    `/project/${normalizedUrl}`
  );
};
